export default __webpack_public_path__ + "static/media/splash.daf4bc9d.png";